import { render, staticRenderFns } from "./sidebarParentItem.vue?vue&type=template&id=495108db&"
import script from "./sidebarParentItem.vue?vue&type=script&lang=js&"
export * from "./sidebarParentItem.vue?vue&type=script&lang=js&"
import style0 from "./sidebarParentItem.vue?vue&type=style&index=0&id=495108db&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/sidebarParentItem.vue
// module id = 336
// module chunks = 30